import type { PageInitInput, PageInitOutput, PageStreamInput } from '@/domains/seek/types';
import { FactoryPsHttpSSE } from '@patsnap-utils/sse';
import { PsHttpService, type PatSnapCommonResponseData } from '@patsnap/tahiti-core/common/ps-http';
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import _ from 'lodash';
import type { PageApi } from '../page-api';

@injectable()
export class PageApiImpl extends PsHttpService implements PageApi {
    get options() {
        return {
            baseURL: `${import.meta.env.VITE_EUREKA_SERVICE_URI}/eureka`,
            headers: {
                'X-API-Version': '1.0',
            },
        };
    }

    pageInit(initData: PageInitInput) {
        return this.post<PatSnapCommonResponseData<PageInitOutput>>({
            url: '/seek/init',
            data: initData,
        }).then((res) => {
            return res.data as PageInitOutput;
        });
    }

    @inject(FactoryPsHttpSSE)
    private _factorySsePsHttp!: FactoryPsHttpSSE;

    getPageStream<T>(streamInput: PageStreamInput) {
        const data = _.omit(streamInput, 'path');
        const sse = this._factorySsePsHttp<T>().init({
            url: `${this.options.baseURL}${streamInput.path}`,
            data,
            hasFinalMessage: (data) => !!data.message,
        });
        return sse;
    }

    stopPageStreamEvent(question_id: string) {
        return this.get<PatSnapCommonResponseData>({
            url: '/seek/stop-event',
            params: {
                question_id,
            },
        })
    }

    seekRewrite(question_id: string, deep_input: string) {
        return this.post<PatSnapCommonResponseData<string>>({
            url: '/seek/rewrite',
            data: { question_id, deep_input },
        }).then((res) => {
            return res.data as string;
        });
    }
}
